<template>

        <div class="content" :key="informationData.id">
      
           <div class="title" :title="informationData.title" >  {{ informationData.title }}</div>
           <div class="date" > 发布日期：{{ informationData.publishTime }} <span v-if="informationData.viewCount">浏览次数：</span><span v-if="informationData.viewCount">{{
                      informationData.viewCount
                    }}次</span></div>
           <div class="text" v-html="informationData.content" ></div>
           <div class="pic">
              <img :src="$axios.defaults.baseURL+informationData.reallyFilePath" alt="" :key="informationData.id">
           </div>
        </div>

</template>
<script>

export default {
     name: 'volunteerActivityDetail',
    
  props: ['id'],
 
  data(){
         
     return {
                 informationData:
                     {
                        //  reallyFilePath:require("../../assets/imgs/水彩画.png"),
                        //  title:'上饶美术馆志愿者宣讲活动走进中学1111111111111111111111111111111111111111111111111111111',
                        //  id:'1',
                        //  publishTime:'2021-03-09',
                        //  viewCount:'913',
                        //  content:'“乡村振兴，既要塑形，也要铸魂。加强乡村文化建设，才能为乡村振兴注入源源不断的精神动力。”近期，全国政协委员、天津美术馆副馆长卢永琇调研了天津附近乡村文化建设的案例。她发现，个人的文化情结在乡村文化建设中有着重要作用，其带头作用应得到更多鼓励；政府要制定好规划和措施，给予更大的支持力度。因此，卢永琇委员认为：“要立足地方特色，传承弘扬优秀传统文化。” 辛丑农历新年刚过，“草树知春”的时节便如期而至。由天津美术馆主办的“春风十里—京津小幅风景油画邀请展”于2021年3月12日至4月20日与观众见面，意在为我们这座城市的艺术园地及精神文化生活，带来一片春的明媚与春的色彩。 受邀参加此次展览的艺术家们来自于京津两地。他们之中有享誉国内美术界的老艺术家，也有正值创作盛年的画坛翘楚，还有活力充沛的青年才俊。他们以经典的油画语言，从不同视角，描摹大千世界的风光景致，展现蓬勃向上的社会生活，揭示其间蕴含的美的韵律。笔致翩翩，美不胜收。 绘画艺术的审美价值从不以篇幅大小分高下。小幅风景油画作为油画艺术与生俱来的一个品种，由于它更接近于画家对艺术的“本真”思考，语境鲜活灵动，因而魅力独具，广受青睐。 京津两地三代艺术家此次带来的这些小幅风景油画作品，显示出他们利用“方寸之间”展示自然界与世间万象丰富面目的不俗功力。在他们笔下，高天阔野、大山广漠、江河林泉、船桥屋舍，不仅美轮美奂、透射着生命的灵性，也寄寓着艺术家的审美理想，是人文与自然的完美结合。必会给人以欣赏的愉悦及审美的启迪。 “兴寄所至，形为图绘”。随着社会发展、时代进步，绘画艺术的创作形态、艺术风格与美学追求，也在不断变化，优秀艺术家为此做出许多可贵的探索与尝试。天津美术馆历来对此高度重视，并给予热诚的关注与支持，今后还会继续这样去做，以使我们的美术园地更加斑斓繁盛。 艺术成就无论大小，都取之于丰富多彩的现实生活，源于艺术家厚重的人生体悟、敏锐的艺术感兴、独出的审美发现，以及脚踏实地、百折不回的创新精神。此次展览也证明，京津两地三代艺术家们笃信这个道理，并坚持付诸实践。唯其如此，漫漫艺途之上，纵有十里春风，也笑看他们独领芳菲。 公众号二维码 上饶美术馆版权所有 工信部备案号：************** 友情链接： 美术馆 首页 新闻资讯 馆藏鉴赏 学术交流 展览陈列 公共教育 观众服务 友情提示： 上饶美术馆周一闭馆（不含节假日） 疫情期间实行分时预约参观。每日可预约时间段如下： 9:00-17:00 地址：上饶市信州区平江道60号'
                     },
                       
        

             }
     
  },
   created()
  {
     this.getInfoDetail();
      
     console.log(111);
  },
  mounted()
  {
     console.log(222);
  },
  activated()
  {
    
     console.log(333);
  },
  deactivated()
  {
  
    console.log(444);
  },
  beforeDestroy()
  {
    
     console.log(555);
  },
  methods:{
      async  getInfoDetail()
       {
            let  url = 'frontapi/volunteer/activity/'+this.id;
            await this.$sr_api.getVolunteerActivityDetail(url).then((res)=>{
              this.informationData.title =  res.data.title;
              this.informationData.id =  res.data.id;
              this.informationData.publishTime =  res.data.publishTime;
              this.informationData.viewCount =  res.data.viewCount;
              this.informationData.content =  res.data.content;
              this.informationData.reallyFilePath = res.data.params.reallyFilePath;
              console.log(this.informationData,'this.informationData');
            })
             this.$forceUpdate();
       }
  }
}
</script>
<style scoped>
    img {
    font-size: 18px;
}
     .content {
        width: 860px;
        height: auto;
        margin-top: 40px;
        padding: 30px 30px 40px;
        background-color: #fff;
        border-radius: 10px;
    }
    .content .title {
        width: 100%;
        text-align: center;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        height: 24px;
        font-size: 24px;
        font-family: SourceHanSansCN;
        font-weight: 500;
        color: #222222;
        line-height: 24px;
    }
     .content .date {
       margin: 20px 0;
        width: 100%;
        text-align: center;
        height: 14px;
        line-height: 14px;
        font-size: 14px;
        font-family: SourceHanSansCN;
        font-weight: 500;
        color: #666666;
     }
    .content .text {
  
            width: 100%;
            height: auto;
font-size: 16px;
line-height: 26px;
  font-family: SourceHanSansCN;
font-weight: 500;
color: #222222;
        }
          .content .pic  {
            margin: 30px auto 0;
            width: 440px;
            height: 440px;
            border-radius: 10px;
          }
           .content .pic > img {
             width: 100%;
             height: 100%;
           }
</style>